(function () {
  function fillSvg(holder, data) {
    if (!holder) return;
    var set = function (selector, value) {
      var node = holder.querySelector(selector);
      if (node) node.textContent = value || '';
      return node;
    };
    var yearsNode = set('.garan-years', data.years);
    if (yearsNode) yearsNode.setAttribute('text-anchor', 'middle');
    set('.garan-brand', data.brand);
    var model = set('.garan-model', data.model);
    if (model) {
      model.setAttribute('text-anchor', 'end');
      model.removeAttribute('textLength');
      model.removeAttribute('lengthAdjust');
      var maxWidth = 118;
      var naturalWidth = 0;
      try {
        naturalWidth = model.getComputedTextLength();
      } catch (err) {
        naturalWidth = 0;
      }
      if (naturalWidth > maxWidth) {
        model.setAttribute('textLength', String(maxWidth));
        model.setAttribute('lengthAdjust', 'spacingAndGlyphs');
      }
    }
  }

  function scopeBigSvg(markup) {
    return String(markup || '')
      .replace(/\.cls-/g, '.garan-big-cls-')
      .replace(/\bclass="([^"]*)"/g, function (_match, classes) {
        return 'class="' + classes.replace(/(^|\s)cls-/g, '$1garan-big-cls-') + '"';
      });
  }

  function lockSmallSvg(holder) {
    if (!holder) return;
    var svg = holder.querySelector('svg');
    if (!svg) return;
    svg.style.background = '#f4f4f4';
    svg.querySelectorAll('.cls-4').forEach(function (el) {
      el.setAttribute('fill', '#f4f4f4');
      el.style.fill = '#f4f4f4';
    });
    svg.querySelectorAll('.cls-1, .cls-2').forEach(function (el) {
      el.setAttribute('fill', '#231f20');
      el.style.fill = '#231f20';
    });
    svg.querySelectorAll('.cls-3').forEach(function (el) {
      el.setAttribute('fill', '#f4f4f4');
      el.style.fill = '#f4f4f4';
    });
    svg.querySelectorAll('.cls-5').forEach(function (el) {
      el.setAttribute('fill', 'none');
      el.style.fill = 'none';
    });
    svg.querySelectorAll('.cls-6').forEach(function (el) {
      el.setAttribute('fill', '#034ea2');
      el.style.fill = '#034ea2';
    });
    svg.querySelectorAll('.cls-7').forEach(function (el) {
      el.setAttribute('fill', '#fff200');
      el.style.fill = '#fff200';
    });
  }

  function fetchSvg(url) {
    return fetch(url).then(function (response) {
      if (!response.ok) throw new Error(String(response.status));
      return response.text();
    });
  }

  var scrollLockY = 0;
  var scrollLockCount = 0;

  function isInsideDialogScroll(target) {
    return !!(target && target.closest && target.closest('.garan-label__dialog-body'));
  }

  function onScrollAttempt(event) {
    if (!scrollLockCount) return;
    if (isInsideDialogScroll(event.target)) return;
    event.preventDefault();
  }

  function onKeyScroll(event) {
    if (!scrollLockCount) return;
    var keys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '];
    if (keys.indexOf(event.key) === -1) return;
    if (isInsideDialogScroll(event.target)) return;
    if (event.target && event.target.closest && event.target.closest('.garan-label__dialog')) return;
    event.preventDefault();
  }

  function onWindowScroll() {
    if (!scrollLockCount) return;
    if (window.scrollY !== scrollLockY) window.scrollTo(0, scrollLockY);
  }

  function lockBodyScroll() {
    if (scrollLockCount === 0) {
      scrollLockY = window.scrollY || window.pageYOffset || 0;
      document.addEventListener('wheel', onScrollAttempt, { passive: false });
      document.addEventListener('touchmove', onScrollAttempt, { passive: false });
      document.addEventListener('keydown', onKeyScroll, { passive: false });
      window.addEventListener('scroll', onWindowScroll, { passive: false });
    }
    scrollLockCount += 1;
  }

  function unlockBodyScroll() {
    if (scrollLockCount === 0) return;
    scrollLockCount -= 1;
    if (scrollLockCount > 0) return;
    document.removeEventListener('wheel', onScrollAttempt);
    document.removeEventListener('touchmove', onScrollAttempt);
    document.removeEventListener('keydown', onKeyScroll);
    window.removeEventListener('scroll', onWindowScroll);
    window.scrollTo(0, scrollLockY);
  }

  function initRoot(root) {
    if (root.getAttribute('data-garan-ready')) return;
    root.setAttribute('data-garan-ready', '1');

    var years = root.getAttribute('data-garan-years') || '';
    var model = root.getAttribute('data-garan-model') || '';
    var brand = root.getAttribute('data-garan-brand') || '';
    var showBig = root.getAttribute('data-garan-show-big') === 'true';
    var smallUrl = root.getAttribute('data-garan-small-url');
    var bigUrl = root.getAttribute('data-garan-big-url');
    var thumb = root.querySelector('[data-garan-thumb]');
    var openBtn = root.querySelector('[data-garan-open]');
    var dialog = root.querySelector('[data-garan-dialog]');
    var closeBtn = root.querySelector('[data-garan-close]');
    var loading = root.querySelector('[data-garan-loading]');
    var bigHolder = root.querySelector('[data-garan-big-holder]');
    var legal = root.querySelector('[data-garan-legal]');
    var modelsNode = root.querySelector('[data-garan-models]');
    var smallMarkup = null;
    var bigMarkup = null;
    var data = { years: years, model: model, brand: brand };
    var models = [];

    try {
      models = modelsNode ? JSON.parse(modelsNode.textContent || '[]') : [];
    } catch (err) {
      models = [];
    }
    if (!models.length && model) models = [model];

    if (dialog && dialog.parentElement !== document.body) {
      document.body.appendChild(dialog);
    }

    function renderThumb() {
      if (!thumb || !smallUrl) return;
      if (smallMarkup) {
        thumb.innerHTML = smallMarkup;
        fillSvg(thumb, data);
        lockSmallSvg(thumb);
        return;
      }
      fetchSvg(smallUrl)
        .then(function (markup) {
          smallMarkup = markup;
          thumb.innerHTML = smallMarkup;
          fillSvg(thumb, data);
          lockSmallSvg(thumb);
        })
        .catch(function () {});
    }

    function renderBigLabels(markup) {
      if (!bigHolder) return;
      bigHolder.innerHTML = '';
      models.forEach(function (modelName) {
        if (!modelName) return;
        var wrap = document.createElement('div');
        wrap.className = 'garan-label__big';
        wrap.innerHTML = markup;
        fillSvg(wrap, {
          years: years,
          model: modelName,
          brand: brand,
        });
        bigHolder.appendChild(wrap);
      });
      bigHolder.hidden = bigHolder.children.length === 0;
    }

    var closeTimer = null;

    function openModal() {
      if (!dialog) return;
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      lockSmallSvg(thumb);
      dialog.style.display = 'flex';
      dialog.showModal();
      lockBodyScroll();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          dialog.classList.add('is-open');
        });
      });
      if (legal) legal.hidden = false;
      if (!showBig) {
        if (bigHolder) bigHolder.hidden = true;
        if (loading) loading.hidden = true;
        return;
      }
      if (bigMarkup && bigHolder) {
        renderBigLabels(bigMarkup);
        lockSmallSvg(thumb);
        if (loading) loading.hidden = true;
        return;
      }
      if (loading) loading.hidden = false;
      if (bigHolder) bigHolder.hidden = true;
      fetchSvg(bigUrl)
        .then(function (markup) {
          bigMarkup = scopeBigSvg(markup);
          if (loading) loading.hidden = true;
          renderBigLabels(bigMarkup);
          lockSmallSvg(thumb);
        })
        .catch(function () {
          if (loading) loading.hidden = true;
        });
    }

    function closeModal() {
      if (!dialog || !dialog.open) return;
      dialog.classList.remove('is-open');
      unlockBodyScroll();
      lockSmallSvg(thumb);
      if (openBtn && typeof openBtn.blur === 'function') openBtn.blur();
      closeTimer = setTimeout(function () {
        if (dialog.open) dialog.close();
        dialog.style.display = 'none';
        closeTimer = null;
      }, 280);
    }

    if (openBtn) {
      openBtn.addEventListener('click', openModal);
      openBtn.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openModal();
        }
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeModal();
      });
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeModal();
      });
      dialog.addEventListener('close', function () {
        dialog.classList.remove('is-open');
        dialog.style.display = 'none';
        unlockBodyScroll();
        lockSmallSvg(thumb);
      });
      dialog.style.display = 'none';
    }

    renderThumb();
  }

  function initAll() {
    document.querySelectorAll('[data-garan-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
